module.exports = __webpack_public_path__ + "static/media/galerija_2017 (36).1d3ce48b.jpg";